import React from "react";
import { Box, TextField } from "@mui/material";
import BusinessLocationsTable from "./BusinessLocationsTable";
import LabeledTextField from "./LabeledTextField";
import SectionHeader from "./SectionHeader";

const GeneralInfoTab = ({ data, onUpdate }) => {
  const updateField = (path, value) => {
    onUpdate(path, value);
  };

  // Get main company (first company in companiesInfo)
  const mainCompany = data.generalInfo?.companiesInfo?.[0] || {};

  return (
    <Box>
      {/* Section: Business borrower info */}
      <Box sx={{ marginBottom: "32px" }}>
        <SectionHeader>Информация о заемщике</SectionHeader>

        <LabeledTextField
          label="Наименование:"
          value={mainCompany?.shortName || ""}
          onChange={(val) => updateField("generalInfo.companiesInfo.0.shortName", val)}
        />

        <LabeledTextField
          label="Главный бухгалтер:"
          value={mainCompany?.accountant || ""}
          onChange={(val) => updateField("generalInfo.companiesInfo.0.accountant", val)}
        />

        <LabeledTextField
          label="Являются ли акцонерами банка или аффилированы с банком"
          value={mainCompany?.bankAffiliated || ""}
          onChange={(val) => updateField("generalInfo.companiesInfo.0.bankAffiliated", val)}
        />

        <BusinessLocationsTable
          data={data.generalInfo?.businessLocations || []}
          onChange={(newData) => updateField("generalInfo.businessLocations", newData)}
        />

        <Box sx={{ marginTop: "16px" }}>
          <Box sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#1A1E24",
            marginBottom: "8px"
          }}>
            Комментарии:
          </Box>
          <TextField
            value={data.generalInfo?.businessLocationComment || ""}
            onChange={(e) => updateField("generalInfo.businessLocationComment", e.target.value)}
            multiline
            rows={3}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "14px",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default GeneralInfoTab;
